import { IconButton } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { Close } from "@mui/icons-material";
import React from "react";
import { palette } from "../theme/palette";

const useStyles = makeStyles({
  closeButton: {
    padding: 0,
    color: (props) =>
      props.dark
        ? palette.typography.black.high
        : palette.typography.white.high,
  },
});

export const CloseButton = ({ onClose, dark = true }) => {
  const classes = useStyles({ dark });

  return (
    <IconButton
      aria-label="close"
      className={classes.closeButton}
      onClick={onClose}
      size="large"
    >
      <Close />
    </IconButton>
  );
};
